import React from 'react'
import Services from '../Home/Services/Services'
import ServicesTopSec from './ServicesTopSec/ServicesTopSec'

function Service() {
  return (
    <>
      <ServicesTopSec />
      <Services />
    </>
  )
}

export default Service
